import { render, staticRenderFns } from "./User.vue?vue&type=template&id=5c31445e&scoped=true&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"
import style0 from "./User.vue?vue&type=style&index=0&id=5c31445e&prod&lang=scss&"
import style1 from "./User.vue?vue&type=style&index=1&id=5c31445e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31445e",
  null
  
)

export default component.exports